var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row wrapper wrapper_padding wizard",class:_vm.authorized ? '' : 'align-items-center'},[_c('div',{staticClass:"col"},[(!_vm.load)?_c('div',{staticClass:"b-loader text-center mt-4 mb-4"}):_vm._e(),(!_vm.authorized)?_c('login_form',{on:{"signedin":_vm.authorize}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }